import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'school-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input('headingvalue') headingtext : any;
  constructor() {  }

  ngOnInit(): void {
  }
}
